import { Link } from 'react-router-dom';
import { categoryMap } from '@/mocks/series';

export default function Footer() {
  return (
    <footer className="border-t border-background-300/60 bg-accent-50 text-foreground-800">
      <div className="mx-auto w-full px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-gradient-to-br from-primary-400 via-primary-500 to-accent-500 text-lg">
                🍉
              </span>
              <span className="font-heading text-2xl text-foreground-950">吃瓜每日</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-6">
              连续剧式吃瓜追更平台。把娱乐圈里那些有反转、有后续、成系列的瓜料整理成可按集追更的栏目，剧情更新、后续进展、第N集、系列跟踪，一网打尽。
            </p>
            <p className="mt-4 flex flex-wrap items-center gap-3 text-sm">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
                <i className="ri-flashlight-line"></i>追更中不迷路
              </span>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-800">
                <i className="ri-fire-line"></i>翻篇更上头
              </span>
            </p>
          </div>

          <nav className="lg:col-span-2" aria-label="站点导航">
            <h4 className="flex items-center gap-1 text-sm font-bold text-foreground-950">
              <i className="ri-compass-line text-primary-500"></i>站点导航
            </h4>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm">
              <li><Link to="/" className="hover:text-primary-600">首页</Link></li>
              <li><Link to="/chasing" className="hover:text-primary-600">追更大厅</Link></li>
              <li><Link to="/about" className="hover:text-primary-600">关于我们</Link></li>
              <li><a href="mailto:hello@chiguameiri.com" className="hover:text-primary-600">商务合作</a></li>
            </ul>
          </nav>

          <nav className="lg:col-span-3" aria-label="追更类型">
            <h4 className="flex items-center gap-1 text-sm font-bold text-foreground-950">
              <i className="ri-stack-line text-primary-500"></i>追更类型
            </h4>
            <ul className="mt-4 grid grid-cols-2 gap-2.5 text-sm">
              {categoryMap.map((c) => (
                <li key={c.key}>
                  <Link
                    to={`/chasing?cat=${c.key}`}
                    className="inline-flex items-center gap-1 whitespace-nowrap hover:text-primary-600"
                  >
                    <i className={`${c.icon} text-accent-600`}></i>
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div className="lg:col-span-2">
            <h4 className="flex items-center gap-1 text-sm font-bold text-foreground-950">
              <i className="ri-chat-3-line text-primary-500"></i>和我们聊聊
            </h4>
            <p className="mt-4 text-sm leading-6">有想追更的系列？<br />欢迎来信告诉我们。</p>
            <a
              href="mailto:hello@chiguameiri.com"
              className="mt-3 inline-flex h-9 items-center whitespace-nowrap rounded-full bg-secondary-500 px-4 text-sm font-bold text-background-50 transition-colors hover:bg-secondary-600"
            >
              <i className="ri-mail-send-line mr-1.5 text-base"></i>联系我们
            </a>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-background-300/60 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} 吃瓜每日 版权所有 · 追剧式吃瓜，不错过每一个瓜的后续发展
          </p>
          <p className="text-xs text-foreground-400">站内内容均为虚构娱乐剧情，仅供娱乐参考，请理性吃瓜。</p>
        </div>
      </div>
    </footer>
  );
}